import React from 'react';

import { AutoExpandingTextareaProps } from './types';
import { FormGroup, Label, StyledTextarea } from './styles';

const CustomAutoExpandingTextarea: React.FC<AutoExpandingTextareaProps> = ({
  value,
  onChange,
  placeholder,
  label,
  disabled,
}) => {
  return (
    <FormGroup>
      {label && <Label>{label}</Label>}
      <StyledTextarea
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        minRows={1}
        disabled={disabled}
      />
    </FormGroup>
  );
};

export default CustomAutoExpandingTextarea;
